import Kendo from './kendo.constants';

export default {
  Kendo
};
